export const DEFAULT_DISPLAY_TAG_LIMIT = 2;
